import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ModalButtonBlockConfig } from '@front-platform/content-builder';
import { modalButtonBlockResolveConfig } from '@front-platform/content-builder';
import { timer } from 'rxjs';
import { Component, input } from '@angular/core';

import { ModalsService } from '@core/services/modals/modals.service';
export interface ModalButtonBlockRuntimeConfig {
  'modal_handle'?: string;
}

export type ModalButtonBlockConfigInput = Partial<
  Omit<ModalButtonBlockConfig, keyof ModalButtonBlockRuntimeConfig> & ModalButtonBlockRuntimeConfig
>;
export type ModalButtonBlockResolvedConfig = Omit<
  ModalButtonBlockConfig,
  keyof ModalButtonBlockRuntimeConfig
> &
  Partial<ModalButtonBlockRuntimeConfig>;
export interface ModalButtonBlockContract extends ConfigComponentContract<
  ModalButtonBlockConfigInput,
  ModalButtonBlockResolvedConfig
> {}

@Component({
  selector: 'app-modal-button-block',
  templateUrl: './modal-button-block.component.html',
  standalone: false,
})
export class ModalButtonBlockComponent implements ModalButtonBlockContract {
  readonly config = input<ModalButtonBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ModalButtonBlockConfig,
    ModalButtonBlockRuntimeConfig
  >(modalButtonBlockResolveConfig, () => ({ config: this.config() }));
  get label(): string {
    return this.resolvedConfig()['label'] as unknown as string;
  }
  get linkUrl(): string | undefined {
    return this.resolvedConfig()['link_url'] as unknown as string | undefined;
  }
  get modalHandle(): string {
    return this.resolvedConfig()['modal_handle'] as unknown as string;
  }
  get size(): 'XXL' | 'L' | 'M' | 'S' | 'XS' {
    return this.resolvedConfig()['size'] as unknown as 'XXL' | 'L' | 'M' | 'S' | 'XS';
  }
  get action(): 'CLOSE_MODAL' | 'GO_TO_URL' {
    return this.resolvedConfig()['action'] as unknown as 'CLOSE_MODAL' | 'GO_TO_URL';
  }
  get style(): 'primary' | 'light' | 'outlined' | 'link' {
    return this.resolvedConfig()['style'] as unknown as 'primary' | 'light' | 'outlined' | 'link';
  }

  constructor(private readonly modalsService: ModalsService) {}

  close(): void {
    if (this.modalHandle) {
      this.modalsService.close(this.modalHandle);
    }
  }

  click(_$event: Event): void {
    timer(0).subscribe(() => {
      this.close();
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ModalButtonBlockComponent, { 'keyAliases': {} });
